import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-divider',
  imports: [CommonModule],
  template: ` <div class="divider" [ngClass]="color()" [ngStyle]="{ height: height() }"></div> `,
  styles: `
    .divider {
      width: 100%;
      background-color: red;
    }

    .divider.first {
      background-color: var(--divider-color1);
    }

    .divider.second {
      background-color: var(--divider-color2);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerComponent {
  color = input<'first' | 'second'>('first');
  height = input<'1px' | '2px'>('1px');
}
